export function getMoveManagerImport(projectSlug: string) {
  switch (projectSlug) {
    case "arnak":
      return import("../../projects/arnak/moveManager");
    case "starship-captains":
      return import("../../projects/starship-captains/moveManager");
    case "slow-machines":
      return import("../../projects/slow-machines/moveManager");
    case "chess":
      return import("../../projects/chess/moveManager");
    case "__template":
      return import("../../projects/__template/moveManager");
    case "__template-ts":
      return import("../../projects/__template-ts/moveManager");
    case "drillers":
      return import("../../projects/drillers/moveManager");
    case "kutnahora":
      return import("../../projects/kutnahora/moveManager");
    case "sneferu":
      return import("../../projects/sneferu/moveManager");
    case "tzolkin":
      return import("../../projects/tzolkin/moveManager");
    case "petz":
      return import("../../projects/petz/moveManager");
    case "seti":
      return import("../../projects/seti/moveManager");
    case "kcd":
      return import("../../projects/kcd/moveManager");
    case "sandbox":
      return import("../../projects/sandbox/moveManager");
    case "wispwood":
      return import("../../projects/wispwood/moveManager");
    case "depot":
      return import("../../projects/depot/moveManager");
    default:
      return import("../../projects/__fallbackImport/moveManager");
  }
}

export function getCustomMovesImport(projectSlug: string) {
  switch (projectSlug) {
    case "arnak":
      return import("../../projects/arnak/customMoves");
    case "starship-captains":
      return import("../../projects/starship-captains/customMoves");
    case "slow-machines":
      return import("../../projects/slow-machines/customMoves");
    case "chess":
      return import("../../projects/chess/customMoves");
    case "__template":
      return import("../../projects/__template/customMoves");
    case "__template-ts":
      return import("../../projects/__template-ts/customMoves");
    case "drillers":
      return import("../../projects/drillers/customMoves");
    case "kutnahora":
      return import("../../projects/kutnahora/customMoves");
    case "sneferu":
      return import("../../projects/sneferu/customMoves");
    case "tzolkin":
      return import("../../projects/tzolkin/customMoves");
    case "petz":
      return import("../../projects/petz/customMoves");
    case "seti":
      return import("../../projects/seti/customMoves");
    case "kcd":
      return import("../../projects/kcd/customMoves");
    case "sandbox":
      return import("../../projects/sandbox/customMoves");
    case "wispwood":
      return import("../../projects/wispwood/customMoves");
    case "depot":
      return import("../../projects/depot/customMoves");
    default:
      return import("../../projects/__fallbackImport/customMoves");
  }
}

export function getHighlightImport(projectSlug: string) {
  switch (projectSlug) {
    case "arnak":
      return import("../../projects/arnak/highlight");
    case "starship-captains":
      return import("../../projects/starship-captains/highlight");
    case "slow-machines":
      return import("../../projects/slow-machines/highlight");
    case "chess":
      return import("../../projects/chess/highlight");
    case "__template":
      return import("../../projects/__template/highlight");
    case "__template-ts":
      return import("../../projects/__template-ts/highlight");
    case "drillers":
      return import("../../projects/drillers/highlight");
    case "kutnahora":
      return import("../../projects/kutnahora/highlight");
    case "sneferu":
      return import("../../projects/sneferu/highlight");
    case "tzolkin":
      return import("../../projects/tzolkin/highlight");
    case "petz":
      return import("../../projects/petz/highlight");
    case "seti":
      return import("../../projects/seti/highlight");
    case "kcd":
      return import("../../projects/kcd/highlight");
    case "sandbox":
      return import("../../projects/sandbox/highlight");
    case "wispwood":
      return import("../../projects/wispwood/highlight");
    case "depot":
      return import("../../projects/depot/highlight");
    default:
      return import("../../projects/__fallbackImport/highlight");
  }
}

export function getCustomTooltipImport(projectSlug: string) {
  switch (projectSlug) {
    case "tzolkin":
      return import("../../projects/tzolkin/customTooltip");
    case "seti":
      return import("../../projects/seti/customTooltip");
    case "kcd":
      return import("../../projects/kcd/customTooltip");
    case "petz":
      return import("../../projects/petz/customTooltip");
    case "depot":
      return import("../../projects/depot/customTooltip");
    default:
      return import("../../projects/__fallbackImport/customTooltip");
  }
}

export function getStatesImport(projectSlug: string) {
  switch (projectSlug) {
    case "arnak":
      return import("../../projects/arnak/states");
    case "starship-captains":
      return import("../../projects/starship-captains/states");
    case "slow-machines":
      return import("../../projects/slow-machines/states");
    case "chess":
      return import("../../projects/chess/states");
    case "__template":
      return import("../../projects/__template/states");
    case "__template-ts":
      return import("../../projects/__template-ts/states");
    case "drillers":
      return import("../../projects/drillers/states");
    case "kutnahora":
      return import("../../projects/kutnahora/states");
    case "sneferu":
      return import("../../projects/sneferu/states");
    case "tzolkin":
      return import("../../projects/tzolkin/states");
    case "petz":
      return import("../../projects/petz/states");
    case "seti":
      return import("../../projects/seti/states");
    case "kcd":
      return import("../../projects/kcd/states");
    case "sandbox":
      return import("../../projects/sandbox/states");
    case "wispwood":
      return import("../../projects/wispwood/states");
    case "depot":
      return import("../../projects/depot/states");
    default:
      return import("../../projects/__fallbackImport/states");
  }
}

export function getChangeLogImport(projectSlug: string) {
  switch (projectSlug) {
    case "arnak":
      return import("../../projects/arnak/_changeLog");
    case "seti":
      return import("../../projects/seti/_changeLog");
    case "kcd":
      return import("../../projects/kcd/_changeLog");
    case "wispwood":
      return import("../../projects/wispwood/_changeLog");
    case "drillers":
      return import("../../projects/drillers/_changeLog");
    default:
      return import("../../projects/__fallbackImport/_changeLog");
  }
}

export function getSetupImport(projectSlug: string) {
  switch (projectSlug) {
    case "arnak":
      return import("../../projects/arnak/setup");
    case "starship-captains":
      return import("../../projects/starship-captains/setup");
    case "slow-machines":
      return import("../../projects/slow-machines/setup");
    case "chess":
      return import("../../projects/chess/setup");
    case "__template":
      return import("../../projects/__template/setup");
    case "__template-ts":
      return import("../../projects/__template-ts/setup");
    case "drillers":
      return import("../../projects/drillers/setup");
    case "kutnahora":
      return import("../../projects/kutnahora/setup");
    case "sneferu":
      return import("../../projects/sneferu/setup");
    case "tzolkin":
      return import("../../projects/tzolkin/setup");
    case "petz":
      return import("../../projects/petz/setup");
    case "seti":
      return import("../../projects/seti/setup");
    case "kcd":
      return import("../../projects/kcd/setup");
    case "sandbox":
      return import("../../projects/sandbox/setup");
    case "wispwood":
      return import("../../projects/wispwood/setup");
    case "depot":
      return import("../../projects/depot/setup");
    default:
      return import("../../projects/__fallbackImport/setup");
  }
}

export function getComponentsImport(projectSlug: string) {
  switch (projectSlug) {
    case "arnak":
      return import("../../projects/arnak/components");
    case "starship-captains":
      return import("../../projects/starship-captains/components");
    case "slow-machines":
      return import("../../projects/slow-machines/components");
    case "chess":
      return import("../../projects/chess/components");
    case "__template":
      return import("../../projects/__template/components");
    case "__template-ts":
      return import("../../projects/__template-ts/components");
    case "drillers":
      return import("../../projects/drillers/components");
    case "kutnahora":
      return import("../../projects/kutnahora/components");
    case "sneferu":
      return import("../../projects/sneferu/components");
    case "tzolkin":
      return import("../../projects/tzolkin/components");
    case "petz":
      return import("../../projects/petz/components");
    case "seti":
      return import("../../projects/seti/components");
    case "kcd":
      return import("../../projects/kcd/components");
    case "sandbox":
      return import("../../projects/sandbox/components");
    case "wispwood":
      return import("../../projects/wispwood/components");
    case "depot":
      return import("../../projects/depot/components");
    default:
      return import("../../projects/__fallbackImport/components");
  }
}
